import { Injectable, Injector } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Router } from "@angular/router";
import { AuthenticationService } from './authentication.service';
 
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router, private inj: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        var expired = false;
        var authReq = req;
        var userInfo = localStorage.getItem('ls.userInfo');
        var objUserInfo = null;
        if(userInfo) {
            objUserInfo = JSON.parse(userInfo);
        }
        if(objUserInfo) {
            var accessToken = objUserInfo.accessToken;
            // Clone the request to add the new header.
            authReq = req.clone({
                setHeaders: {
                    Authorization: ('Bearer ' + accessToken)
                }
            });
            //
            if(Date.now() >= objUserInfo.expiresIn && req.url.indexOf("login") < 0) {
                expired = true;
            }
        }
    
        // Pass on the cloned request instead of the original request.
        return next.handle(authReq).catch(err => {
                var gettingRefreshToken = false;
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401 || err.status === 403 || expired == true) {
                        gettingRefreshToken = true;
                        //
                        //workaround for a bug in angular 4.3.x: https://github.com/angular/angular/issues/18224
                        let authenticationService = this.inj.get(AuthenticationService);
                        return authenticationService.getRefreshToken().mergeMap(
                            response => {
                                let responseData: any = response['data'] ;
                                //
                                var now = new Date();
                                now.setSeconds(now.getSeconds() + responseData.expires_in);
                                //
                                let userInfo = {
                                    accessToken: responseData.access_token,
                                    refreshToken: responseData.refresh_token,
                                    scope: responseData.scope,
                                    username: (objUserInfo != null ? objUserInfo.username : ''),
                                    expiresIn: now.getTime()        
                                };
                                localStorage.setItem("ls.userInfo", JSON.stringify(userInfo));
                                //
                                let retryRequest = req.clone({
                                    setHeaders: {
                                        Authorization: ('Bearer ' + responseData.access_token)
                                    }
                                })
                                return next.handle(retryRequest);
                            }
                        );
                    } 
                    else if (err.status === 500) {
                        localStorage.removeItem('ls.userInfo');
                        if(this.router.url.indexOf("login") < 0) {
                            this.router.navigate(['login'], {queryParams: { returnUrl: this.router.url }});
                        }
                    }
                } 
                
                if(!gettingRefreshToken) {
                    return Observable.throw(err);
                }
            });
    }
}


// WEBPACK FOOTER //
// /Users/Anders/workspace/DOFBasenCli/src/app/share/security/auth-interceptor.ts